import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  ExperienceOfferRelatedLocation,
  getExperienceOfferRelatedLocations,
  updateExperienceOfferRelatedLocation,
} from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetExperienceOfferRelatedLocations(offerId: string) {
  return useQuery({
    queryKey: experiencesQueryKeys.relatedLocations(offerId),
    queryFn: ({ signal }) => getExperienceOfferRelatedLocations(offerId, signal).then((response) => response.result),
    enabled: !!offerId,
  });
}

export function useUpdateExperienceOfferRelatedLocation(offerId: string) {
  const queryClient = useQueryClient();
  const queryKey = experiencesQueryKeys.relatedLocations(offerId);

  return useMutation({
    mutationFn: ({ locationId, excluded }: { locationId: string; excluded: boolean }) =>
      updateExperienceOfferRelatedLocation(offerId, locationId, excluded).then((response) => response.result),
    onMutate: () => queryClient.cancelQueries({ queryKey }),
    onSuccess: (updatedLocation) => {
      queryClient.setQueryData<ExperienceOfferRelatedLocation[]>(queryKey, (locations) =>
        locations?.map((location) => (location.id === updatedLocation.id ? updatedLocation : location)),
      );
      return queryClient.invalidateQueries({ queryKey });
    },
  });
}
